export enum PopoverTrigger {
  HOVER = "hover",
  CLICK = "click",
}
